import { country, cta, flag, link } from "./AudienceIndicator.css";

export default function AudienceIndicator({
	label,
	src,
	url,
}: { label: string; src: string; url: string }) {
	return (
		<a href={url} className={link}>
			<img src={src} alt={`Flag for ${label}`} className={flag} />
			<span className={country}>{label}</span>
			<span className={cta}>Change</span>
		</a>
	);
}
